import app from 'flarum/forum/app';
const patterns = new Map();
export function parseList(value) {
  return value.split(/[\n,]+/).map(entry => entry.trim()).filter(entry => entry !== '');
}
export default function matchesList(url, entries) {
  if (entries.length === 0) return false;
  const subject = subjectOf(url);
  if (subject === null) return false;
  return entries.some(entry => {
    const pattern = patternFor(entry);
    return pattern !== null && pattern.test(subject);
  });
}
export function allowsUrl(url) {
  const allowlist = parseList(app.forum.attribute('datlechin-link-preview.allowlist') ?? '');
  const blocklist = parseList(app.forum.attribute('datlechin-link-preview.blocklist') ?? '');
  if (allowlist.length > 0 && !matchesList(url, allowlist)) return false;
  return !matchesList(url, blocklist);
}
function subjectOf(url) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  const host = parsed.hostname.toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
  return host + parsed.pathname.replace(/\/$/, '') + parsed.search;
}
function normalise(entry) {
  const value = entry.trim();
  const authority = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value.replace(/^\/+/, '')}`;
  let parsed;
  try {
    parsed = new URL(authority);
  } catch {
    return '';
  }
  const host = parsed.hostname.toLowerCase().replace(/\.$/, '').replace(/^www\./, '');
  return host + parsed.pathname.toLowerCase().replace(/\/+$/, '');
}
function patternFor(entry) {
  if (patterns.has(entry)) return patterns.get(entry) ?? null;
  const pattern = compile(entry);
  patterns.set(entry, pattern);
  return pattern;
}
function compile(entry) {
  const normalised = normalise(entry);
  if (normalised === '') return null;
  const slash = normalised.indexOf('/');
  const host = slash === -1 ? normalised : normalised.slice(0, slash);
  const path = slash === -1 ? null : normalised.slice(slash);
  const hostSource = escape(host).replace(/\\\*/g, '[^.]*');
  const source = path === null ? `^(?:[^/?]+\\.)?${hostSource}(?:[/?].*)?$` : `^${hostSource}${escape(path).replace(/\\\*/g, '.*')}(?:[/?].*)?$`;
  return new RegExp(source, 'i');
}
function escape(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
flarum.reg.add('datlechin-link-preview', 'forum/utils/matchesList', matchesList);